export default [{
  value: '',
  label: '全部'
}, {
  value: '0',
  label: '禁用'
}, {
  value: '1',
  label: '启用'
}];



// WEBPACK FOOTER //
// ./src/service/constant/EnableStatus.js